import { useState, useEffect, useRef } from 'react';
// este hook permite saber el tamaño de la pantalla en todo momento!!
const useResize = (BREAKPOINT_MOBIL = 768) => {
  const [isMobil, setIsMobil] = useState(false);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const handleUpdate = () => {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    setIsMobil(currentWidth <= BREAKPOINT_MOBIL);

    setWidth(currentWidth);
    setHeight(currentHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', handleUpdate);

    handleUpdate();

    return () => window.removeEventListener('resize', handleUpdate);
  }, [window.innerWidth]);
  return [width, isMobil, height];
};

export function useResizeRb(callback) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    window.addEventListener('resize', callbackRef.current);

    return () => {
      window.removeEventListener('resize', callbackRef.current);
    };
  }, []);
}

export default useResize;
